import axiosInstance, { axiosInstanceV3 } from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';

// @ List all admin docs
export const docsList = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/admin_doc_list`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Show admin doc details
export const docGet = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/admin_doc_get`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Update admin doc details
export const docUpdate = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/admin_doc_update`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Create admin doc details
export const docCreate = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/admin_doc_create`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
